<mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <input matInput [(ngModel)]="monthAndYear"
                    [matDatepicker]="picker"
                    (dateChange)="emitDateChange($event)" />
    <mat-hint>MM/YYYY</mat-hint>
    <mat-datepicker-toggle
      matSuffix
      [for]="picker">
    </mat-datepicker-toggle>
    <mat-datepicker #picker [startView]="'year'"
                    (monthSelected)="monthChanged($event, picker)">
    </mat-datepicker>
  </mat-form-field>